import React from 'react';
import { Link } from 'react-router-dom';
import '../CSS/styles.css';

const Projects = () => {
  return (
    <>
      <div className='container col-xxl-10 px-4 py-2'>
        <div className='row align-items-center g-5 py-5'>
          <div className='col-10 col-sm-8 col-lg-6'>
            <img
              src={require(`../Images/Projects/food-recipes.png`)}
              className='d-block me-lg-auto img-fluid app-screenshot'
              alt='Eat Healthy food recipes app screen'
              width='250'
              height='500'
              loading='lazy'
            />
          </div>

          <div className='col-lg-6'>
            <div className='feature col'>
              <div className='feature-icon'>
                <h2 className='display-5 fw-bold lh-1 mb-3'>CleanBowl: Healthy Eating</h2>
              </div>
              <p className='py-3 text-secondary'>
                Eat better with meal planning, nutrition tracking, barcode scanning, and healthy recipes built around your goals.
                CleanBowl makes it easier to plan meals, track nutrition, and stay consistent without making food logging feel complicated.
                Discover healthy recipes, save your favorites, import recipes from the web, scan meals and packaged foods, and get personalized daily calorie and macro goals based on your profile.
              </p>
              <div className='d-grid gap-2 d-md-flex justify-content-md-start'>
                <a
                  className='btn btn-outline-dark   px-4 me-md-2'
                  href='https://apps.apple.com/us/app/eat-healthy-food-recipes/id1580294209'>
                  <i className='fab fa-apple' aria-hidden='true'></i> Download
                </a>

                <Link
                  className='btn btn-dark px-4 me-md-2'
                  to='/food-recipes-policies'
                  style={{ textDecoration: 'none' }}>
                  Privacy Policy
                </Link>
              </div>
            </div>
          </div>
        </div>

        <hr className='featurette-divider container' />

        <div className='row flex-lg-row-reverse align-items-center g-5 py-5'>
          <div className='col-10 col-sm-8 col-lg-6'>
            <img
              src={require(`../Images/Projects/ropefit.png`)}
              className='d-block mx-lg-auto img-fluid app-screenshot'
              alt='Ropefit app workout summary screen'
              width='250'
              height='500'
              loading='lazy'
            />
          </div>

          <div className='col-lg-6'>
            <div className='feature col'>
              <div className='feature-icon'>
                <h2 className='display-5 fw-bold lh-1 mb-3'>
                  Jump Rope Tracker | Ropefit
                </h2>
              </div>
              <p className='py-3 text-secondary'>
                The ultimate smart jump rope companion! RopeFit transforms your
                jump rope sessions into engaging, trackable workouts that keep
                you motivated and moving.
              </p>
              <div className='d-grid gap-2 d-md-flex justify-content-md-start'>
                <a
                  className='btn btn-outline-dark   px-4 me-md-2'
                  href='https://apps.apple.com/us/app/jump-rope-tracker-ropefit/id6753272391'>
                  <i className='fab fa-apple' aria-hidden='true'></i> Download
                </a>

                <Link
                  className='btn btn-dark px-4 me-md-2'
                  to='/ropefit-policy'
                  style={{ textDecoration: 'none' }}>
                  Privacy Policy
                </Link>
              </div>
            </div>
          </div>
        </div>

        <hr className='featurette-divider container' />

        <div className='row flex-lg-row-reverse align-items-center g-5'>
          <div className='col-lg-6'>
            <div className='feature col'>
              <div className='feature-icon'>
                <h2 className='display-5 fw-bold lh-1 mb-3'>TickFlip Clock</h2>
              </div>
              <p className='py-3 text-secondary'>
                TickFlip is a sleek, minimalist flip clock designed to keep you
                focused and on time. Whether you’re working, studying, or just
                love a clean desk setup, TickFlip brings a retro-inspired flip
                clock to your device with a modern touch.
              </p>
              <div className='d-grid gap-2 d-md-flex justify-content-md-start'>
                <a
                  className='btn btn-outline-dark   px-4 me-md-2'
                  href='https://apps.apple.com/us/app/tickflip-clock/id6751864978'>
                  <i className='fab fa-apple' aria-hidden='true'></i> Download
                </a>

                <Link
                  className='btn btn-dark px-4 me-md-2'
                  to='/tickflipclock-policy'
                  style={{ textDecoration: 'none' }}>
                  Privacy Policy
                </Link>
              </div>
            </div>
          </div>

          <div className='col-10 col-sm-8 col-lg-6'>
            <img
              src={require(`../Images/Projects/TickFlipClock.png`)}
              className='d-block mx-lg-auto img-fluid app-screenshot'
              alt='TickFlip Clock app screen'
              width='250'
              height='500'
              loading='lazy'
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Projects;
